import { signOut } from "../api";
import { displayName, initials } from "../format";
import type { Me } from "../types";

/** The account corner: who is signed in, and the way out. */
export function Identity({ me }: { me: Me }) {
  const name = displayName(me);
  return (
    <div className="account">
      <div className="avatar" aria-hidden="true">
        {initials(name)}
      </div>
      <div className="who">
        <div className="name">{name}</div>
        <div className="sub">{me.email}</div>
      </div>
      <button className="signout" onClick={() => void signOut()}>
        Sign out
      </button>
    </div>
  );
}
